__turbopack_context__.v({
  "anchoredToBottom": "Socials-module-scss-module__B9WXuq__anchoredToBottom",
  "anchoredToLeft": "Socials-module-scss-module__B9WXuq__anchoredToLeft",
  "socialLink": "Socials-module-scss-module__B9WXuq__socialLink",
  "socialLinkContainer": "Socials-module-scss-module__B9WXuq__socialLinkContainer",
});
